import Joi from '@hapi/joi'

export const FactoryRouteWeighReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    divisionID: Joi.number().required().label("Route").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division Route`
    }),
    date: Joi.string().invalid("").required().label("Date")
}